module.exports = __webpack_public_path__ + "media/drc-video.90e6431a.mp4";